
















import {Component, Prop, Vue} from 'vue-property-decorator';
import JdsEntrySlot from "@/design-system/components/JdsEntrySlot.vue"
@Component({
    components: {JdsEntrySlot}
})
export default class JdsAttributeField extends Vue {
}
